export function show_page_loader(message = 'Loading...', logo_src = null) {
  const loader = document.getElementById('loader');
  if (!loader) return;

  const text = loader.querySelector('.loader-text');
  if (text) text.textContent = message;

  const logo = loader.querySelector('#loader-logo-img, .loader-logo img');
  if (logo && logo_src) logo.src = logo_src;

  loader.style.display = 'flex';
  loader.classList.remove('hidden');
}

export function hide_page_loader() {
  const loader = document.getElementById('loader');
  if (!loader) return;

  loader.classList.add('hidden');
}